import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MaterialDatatable from "material-datatable";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import * as moment from "moment-timezone";
import Login from '../common/login';

const cookies = new Cookies();
const role = Number(localStorage.getItem('role'));



class Selles_Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            from: new Date(),
            to: new Date(),
            spin: false,
            serch: false,
            total_orders: 0,
            total_items: 0,
            items_cost: 0,
            orders_cost: 0,
            pages: [],
            shiper: [],
            company: 'All',
            page: ''
        };
    }

    getMuiTheme = () => createMuiTheme({
        overrides: {
            MuiTableCell: {
                root: {
                    textAlign: 'right',
                    fontSize: '14px',
                    padding: '16px 12px',
                    borderBottom: '1px solid #e5e7eb',
                    color: '#374151',
                    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
                    '@media (max-width: 768px)': {
                        fontSize: '12px',
                        padding: '12px 8px'
                    }
                },
                head: {
                    backgroundColor: "#f8fafc",
                    fontWeight: "700",
                    color: "#1f2937",
                    borderBottom: "2px solid #d1d5db",
                    fontSize: '15px',
                    '@media (max-width: 768px)': {
                        fontSize: '13px'
                    }
                }
            },
            MuiTableContainer: {
                root: {
                    borderRadius: '16px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                    border: '1px solid #e5e7eb',
                    overflow: 'auto',
                    maxWidth: '100%'
                }
            },
            MuiTable: {
                root: {
                    minWidth: '100%',
                    tableLayout: 'auto'
                }
            },
            MuiTableRow: {
                root: {
                    '&:nth-child(even)': {
                        backgroundColor: '#f9fafb'
                    },
                    '&:hover': {
                        backgroundColor: '#f3f4f6 !important'
                    }
                }
            },
            MuiTablePagination: {
                root: {
                    color: '#374151',
                    borderTop: '1px solid #e5e7eb',
                    backgroundColor: '#f8fafc'
                },
                toolbar: {
                    '@media (max-width: 768px)': {
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        gap: '8px',
                        padding: '12px'
                    }
                },
                selectIcon: {
                    color: '#6b7280'
                },
                actions: {
                    '@media (max-width: 768px)': {
                        margin: 0
                    }
                }
            },
            MuiIconButton: {
                root: {
                    color: '#6b7280',
                    '&:hover': {
                        backgroundColor: 'rgba(59, 130, 246, 0.1)',
                        color: '#3b82f6'
                    }
                }
            },
            MuiToolbar: {
                root: {
                    backgroundColor: '#f8fafc',
                    borderBottom: '1px solid #e5e7eb',
                    '@media (max-width: 768px)': {
                        flexDirection: 'column',
                        alignItems: 'stretch',
                        gap: '12px',
                        padding: '16px 12px'
                    }
                }
            },
            MuiTextField: {
                root: {
                    '& .MuiInputBase-root': {
                        backgroundColor: 'white',
                        borderRadius: '8px'
                    }
                }
            }
        }
    });

    componentDidMount() {
        const header = { "Content-Type": "application/json", token: cookies.get("token") };

        axios.get(`${host}dashbord/shiper/all/`, { headers: header })
            .then(res => this.setState({ shiper: res.data.shiper }));

        axios.get(`${host}users/pages/name/all`, { headers: header })
            .then(res => this.setState({ pages: res.data.data.pages }));
    }

    Orders = (pageId) => {
        const date1 = moment(this.state.from).format("DD/MM/YYYY");
        const date2 = moment(this.state.to).format("DD/MM/YYYY");
        const header = { "Content-Type": "application/json", token: cookies.get("token") };

        axios.get(`${host}users/printed/orders/reports?from=${date1}&to=${date2}&page=${pageId}&company=${this.state.company}`, { headers: header })
            .then(res => {
                const orders = res.data.data.items.map((item, i) => ({
                    id: i + 1,
                    name: item.name,
                    count: item.count
                }));
         
                
                this.setState({
                    orders,
                    total_orders: res.data.data.order_count,
                    total_items: res.data.data.items_sum,
                    items_cost: res.data.data.items_cost,
                    orders_cost: res.data.data.sells,
                    serch: true,
                    spin: false
                });
            })
            .catch(() => this.setState({ spin: false }));
    };

    render() {
        if (!cookies.get("token")) return <Login />;

        const statsCards = [
            {
                title: "مجموع الطلبات",
                value: this.state.total_orders,
                icon: "📦",
                gradient: "linear-gradient(135deg, #06b6d4, #0891b2)",
                shadowColor: "rgba(6, 182, 212, 0.3)"
            },
            {
                title: "مجموع القطع",
                value: this.state.total_items,
                icon: "📊",
                gradient: "linear-gradient(135deg, #8b5cf6, #7c3aed)",
                shadowColor: "rgba(139, 92, 246, 0.3)"
            },
            ...(role === -1 ? [{
                title: "أسعار المواد",
                value: this.state.items_cost,
                icon: "💰",
                gradient: "linear-gradient(135deg, #f59e0b, #d97706)",
                shadowColor: "rgba(245, 158, 11, 0.3)"
            }] : []),
            ...(role !== 0 ? [{
                title: "مجموع المبيعات",
                value: this.state.orders_cost,
                icon: "💵",
                gradient: "linear-gradient(135deg, #ef4444, #dc2626)",
                shadowColor: "rgba(239, 68, 68, 0.3)"
            }] : [])
        ];

        return (
            <Context.Consumer>
                {ctx => (
                    <div style={{
                        minHeight: '100vh',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        padding: '16px',
                        fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
                        direction: 'rtl'
                    }}>
                        <style>
                            {`
                                @keyframes spin {
                                    from { transform: rotate(0deg); }
                                    to { transform: rotate(360deg); }
                                }
                                
                                @keyframes slideIn {
                                    from { opacity: 0; transform: translateY(-20px); }
                                    to { opacity: 1; transform: translateY(0); }
                                }
                                
                                @keyframes fadeIn {
                                    from { opacity: 0; }
                                    to { opacity: 1; }
                                }
                                
                                .form-control {
                                    width: 100%;
                                    padding: 12px 16px;
                                    border: 2px solid #e2e8f0;
                                    border-radius: 12px;
                                    font-size: 14px;
                                    background: white;
                                    transition: all 0.2s ease;
                                    box-sizing: border-box;
                                    height: 50px;
                                }
                                
                                .form-control:focus {
                                    outline: none;
                                    border-color: #3b82f6;
                                    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
                                }
                                
                                @media (max-width: 768px) {
                                    .form-control {
                                        padding: 10px 12px;
                                        font-size: 16px;
                                        height: 50px;
                                    }
                                }
                                
                                .react-datepicker-wrapper {
                                    width: 100%;
                                }
                                
                                .react-datepicker__input-container input {
                                    width: 100% !important;
                                }
                                
                                .stats-card {
                                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                                }
                                
                                .stats-card:hover {
                                    transform: translateY(-8px) scale(1.02);
                                }
                                
                                @media (max-width: 768px) {
                                    .stats-grid {
                                        grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)) !important;
                                        gap: 12px !important;
                                    }
                                    
                                    .stats-card {
                                        padding: 16px !important;
                                    }
                                    
                                    .stats-card .icon {
                                        font-size: 20px !important;
                                        margin-bottom: 6px !important;
                                    }
                                    
                                    .stats-card .value {
                                        font-size: 18px !important;
                                        margin-bottom: 4px !important;
                                    }
                                    
                                    .stats-card .title {
                                        font-size: 11px !important;
                                    }
                                }
                                
                                @media (max-width: 480px) {
                                    .stats-grid {
                                        grid-template-columns: repeat(2, 1fr) !important;
                                    }
                                }
                                
                                @media (max-width: 768px) {
                                    .desktop-table {
                                        display: none !important;
                                    }
                                    
                                    .mobile-cards {
                                        display: block !important;
                                    }
                                }
                                
                                @media (min-width: 769px) {
                                    .desktop-table {
                                        display: block !important;
                                    }
                                    
                                    .mobile-cards {
                                        display: none !important;
                                    }
                                }
                            `}
                        </style>

                        <div style={{
                            maxWidth: '1400px',
                            margin: '0 auto',
                            background: 'rgba(255, 255, 255, 0.95)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '24px',
                            padding: 'clamp(16px, 4vw, 32px)',
                            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                            animation: 'slideIn 0.6s ease-out'
                        }}>
                            {/* Back Button */}
                            <button
                                onClick={() => window.history.back()}
                                style={{
                                    background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                                    color: "white",
                                    padding: "12px 24px",
                                    border: "none",
                                    borderRadius: '16px',
                                    fontSize: 14,
                                    fontWeight: '600',
                                    cursor: "pointer",
                                    boxShadow: "0 4px 14px 0 rgba(99, 102, 241, 0.3)",
                                    transition: 'all 0.2s ease',
                                    marginBottom: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}
                                onMouseOver={(e) => {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 6px 20px 0 rgba(99, 102, 241, 0.4)';
                                }}
                                onMouseOut={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 4px 14px 0 rgba(99, 102, 241, 0.3)';
                                }}
                            >
                                <span style={{ fontSize: '16px' }}>←</span>
                                رجوع
                            </button>

                            {/* Header */}
                            <div style={{
                                background: 'linear-gradient(135deg, #1e293b, #334155)',
                                color: "white",
                                padding: 'clamp(20px, 5vw, 32px)',
                                borderRadius: '20px',
                                marginBottom: '32px',
                                textAlign: 'center',
                                position: 'relative',
                                overflow: 'hidden'
                            }}>
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    background: 'linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)',
                                    animation: 'slideIn 2s ease-in-out infinite alternate'
                                }}></div>
                                <h1 style={{
                                    margin: 0,
                                    fontSize: 'clamp(20px, 5vw, 32px)',
                                    fontWeight: '700',
                                    position: 'relative',
                                    zIndex: 1
                                }}>
                                    📊 تقارير الطلبات حسب التاريخ
                                </h1>
                                <p style={{
                                    margin: '8px 0 0 0',
                                    opacity: 0.9,
                                    fontSize: 'clamp(14px, 3vw, 16px)',
                                    position: 'relative',
                                    zIndex: 1
                                }}>
                                    تحليل شامل لبيانات المبيعات والطلبات
                                </p>
                            </div>

                            {/* Filters Section */}
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                                gap: '20px',
                                marginBottom: '32px'
                            }}>
                                {/* From Date */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
                                    padding: '20px',
                                    borderRadius: '16px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <label style={{
                                        fontWeight: "600",
                                        color: '#374151',
                                        display: 'block',
                                        marginBottom: '12px',
                                        fontSize: '14px'
                                    }}>
                                        📅 من تاريخ:
                                    </label>
                                    <DatePicker
                                        selected={this.state.from}
                                        onChange={(date) => this.setState({ from: date })}
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control"
                                    />
                                </div>

                                {/* To Date */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
                                    padding: '20px',
                                    borderRadius: '16px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <label style={{
                                        fontWeight: "600",
                                        color: '#374151',
                                        display: 'block',
                                        marginBottom: '12px',
                                        fontSize: '14px'
                                    }}>
                                        📅 إلى تاريخ:
                                    </label>
                                    <DatePicker
                                        selected={this.state.to}
                                        onChange={(date) => this.setState({ to: date })}
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control"
                                    />
                                </div>

                                {/* Shipper */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
                                    padding: '20px',
                                    borderRadius: '16px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <label style={{
                                        fontWeight: "600",
                                        color: '#374151',
                                        display: 'block',
                                        marginBottom: '12px',
                                        fontSize: '14px'
                                    }}>
                                        🚚 المندوب:
                                    </label>
                                    <select
                                        onChange={(e) => this.setState({ company: e.target.value })}
                                        className="form-control"
                                    >
                                        <option value="All">كل المندوبين</option>
                                        {this.state.shiper.map(s =>
                                            <option key={s.name} value={s.name}>{s.name}</option>
                                        )}
                                    </select>
                                </div>

                                {/* Page */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
                                    padding: '20px',
                                    borderRadius: '16px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <label style={{
                                        fontWeight: "600",
                                        color: '#374151',
                                        display: 'block',
                                        marginBottom: '12px',
                                        fontSize: '14px'
                                    }}>
                                        📄 الصفحة:
                                    </label>
                                    <select id="selectPage" className="form-control">
                                        <option value="All">كل الصفحات</option>
                                        {this.state.pages.map(p =>
                                            <option key={p.id} value={p.id}>{p.name}</option>
                                        )}
                                    </select>
                                </div>
                            </div>

                            {/* Search Button */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginBottom: '32px'
                            }}>
                                <button
                                    onClick={() => {
                                        const select = document.getElementById('selectPage');
                                        const text = select.options[select.selectedIndex].text;
                                        this.setState({ page: text, spin: true });
                                        this.Orders(select.value);
                                    }}
                                    disabled={this.state.spin}
                                    style={{
                                        background: this.state.spin
                                            ? 'linear-gradient(135deg, #9ca3af, #6b7280)'
                                            : 'linear-gradient(135deg, #10b981, #059669)',
                                        color: "white",
                                        padding: "16px 32px",
                                        border: "none",
                                        borderRadius: '16px',
                                        cursor: this.state.spin ? "not-allowed" : "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "12px",
                                        fontSize: '16px',
                                        fontWeight: '600',
                                        minWidth: '200px',
                                        boxShadow: this.state.spin
                                            ? 'none'
                                            : '0 4px 14px 0 rgba(16, 185, 129, 0.3)',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseOver={(e) => {
                                        if (!this.state.spin) {
                                            e.target.style.transform = 'translateY(-2px)';
                                            e.target.style.boxShadow = '0 6px 20px 0 rgba(16, 185, 129, 0.4)';
                                        }
                                    }}
                                    onMouseOut={(e) => {
                                        if (!this.state.spin) {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = '0 4px 14px 0 rgba(16, 185, 129, 0.3)';
                                        }
                                    }}
                                >
                                    {this.state.spin && (
                                        <div
                                            style={{
                                                width: "20px",
                                                height: "20px",
                                                border: "3px solid rgba(255,255,255,0.3)",
                                                borderTop: "3px solid white",
                                                borderRadius: "50%",
                                                animation: "spin 1s linear infinite"
                                            }}
                                        />
                                    )}
                                    <span style={{ fontSize: '18px' }}>🔍</span>
                                    {this.state.spin ? "جاري البحث..." : "بحث وتحليل"}
                                </button>
                            </div>

                            {/* Results Section */}
                            {this.state.serch && (
                                <div style={{ animation: 'fadeIn 0.5s ease-out' }}>
                                    {/* Statistics Cards */}
                                    <div className="stats-grid" style={{
                                        display: 'grid',
                                        gridTemplateColumns: `repeat(${statsCards.length}, 1fr)`,
                                        gap: '20px',
                                        marginBottom: '32px'
                                    }}>
                                        {statsCards.map((card, index) => (
                                            <div 
                                                key={index}
                                                className="stats-card"
                                                style={{
                                                    background: card.gradient,
                                                    color: "white",
                                                    padding: '24px',
                                                    borderRadius: '20px',
                                                    textAlign: 'center',
                                                    boxShadow: `0 8px 25px -5px ${card.shadowColor}`,
                                                    minHeight: '140px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <div className="icon" style={{ 
                                                    fontSize: '28px', 
                                                    marginBottom: '8px' 
                                                }}>
                                                    {card.icon}
                                                </div>
                                                <div className="value" style={{ 
                                                    fontSize: 'clamp(20px, 4vw, 24px)', 
                                                    fontWeight: '700', 
                                                    marginBottom: '4px',
                                                    lineHeight: 1
                                                }}>
                                                    {card.value.toLocaleString()}
                                                </div>
                                                <div className="title" style={{ 
                                                    opacity: 0.9, 
                                                    fontSize: 'clamp(12px, 2.5vw, 14px)',
                                                    lineHeight: 1.2,
                                                    fontWeight: '500'
                                                }}>
                                                    {card.title}
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Data Table */}
                                    <div style={{
                                        background: 'white',
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                                        border: '1px solid #e5e7eb',
                                        width: '100%'
                                    }}>
                                        {/* Table Header */}
                                        <div style={{
                                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                            color: 'white',
                                            padding: '20px 24px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            borderBottom: '2px solid #e5e7eb'
                                        }}>
                                            <h3 style={{
                                                margin: 0,
                                                fontSize: '18px',
                                                fontWeight: '700',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px'
                                            }}>
                                                📋 تفاصيل المنتجات
                                            </h3>
                                            <div style={{
                                                fontSize: '14px',
                                                background: 'rgba(255, 255, 255, 0.2)',
                                                padding: '6px 12px',
                                                borderRadius: '20px',
                                                backdropFilter: 'blur(10px)'
                                            }}>
                                                {this.state.orders.length} منتج
                                            </div>
                                        </div>

                                        {/* Desktop Table View */}
                                        <div style={{
                                            display: 'block',
                                            '@media (max-width: 768px)': {
                                                display: 'none'
                                            }
                                        }} className="desktop-table">
                                            <table style={{
                                                width: '100%',
                                                borderCollapse: 'collapse',
                                                fontSize: '14px'
                                            }}>
                                                <thead>
                                                    <tr style={{
                                                        background: '#f8fafc',
                                                        borderBottom: '2px solid #e2e8f0'
                                                    }}>
                                                        <th style={{
                                                            padding: '16px 20px',
                                                            textAlign: 'center',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            fontSize: '15px',
                                                            width: '80px'
                                                        }}>#</th>
                                                        <th style={{
                                                            padding: '16px 20px',
                                                            textAlign: 'right',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            fontSize: '15px'
                                                        }}>اسم المنتج</th>
                                                        <th style={{
                                                            padding: '16px 20px',
                                                            textAlign: 'center',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            fontSize: '15px',
                                                            width: '120px'
                                                        }}>العدد</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.orders.map((order, index) => (
                                                        <tr key={index} style={{
                                                            borderBottom: '1px solid #f1f5f9',
                                                            backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9fafb',
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                        onMouseOver={(e) => {
                                                            e.currentTarget.style.backgroundColor = '#f3f4f6';
                                                            e.currentTarget.style.transform = 'scale(1.01)';
                                                        }}
                                                        onMouseOut={(e) => {
                                                            e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#f9fafb';
                                                            e.currentTarget.style.transform = 'scale(1)';
                                                        }}>
                                                            <td style={{
                                                                padding: '16px 20px',
                                                                textAlign: 'center',
                                                                fontWeight: '600',
                                                                color: '#6b7280'
                                                            }}>
                                                                <span style={{
                                                                    background: 'linear-gradient(135deg, #667eea, #764ba2)',
                                                                    color: 'white',
                                                                    padding: '4px 8px',
                                                                    borderRadius: '8px',
                                                                    fontSize: '12px',
                                                                    fontWeight: '600'
                                                                }}>
                                                                    {order.id}
                                                                </span>
                                                            </td>
                                                            <td style={{
                                                                padding: '16px 20px',
                                                                textAlign: 'right',
                                                                color: '#374151',
                                                                fontWeight: '500'
                                                            }}>
                                                                {order.name}
                                                            </td>
                                                            <td style={{
                                                                padding: '16px 20px',
                                                                textAlign: 'center',
                                                                fontWeight: '600'
                                                            }}>
                                                                <span style={{
                                                                    background: 'linear-gradient(135deg, #10b981, #059669)',
                                                                    color: 'white',
                                                                    padding: '6px 12px',
                                                                    borderRadius: '12px',
                                                                    fontSize: '13px',
                                                                    fontWeight: '600'
                                                                }}>
                                                                    {order.count}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Mobile Cards View */}
                                        <div style={{
                                            display: 'none',
                                            '@media (max-width: 768px)': {
                                                display: 'block'
                                            }
                                        }} className="mobile-cards">
                                            {this.state.orders.map((order, index) => (
                                                <div key={index} style={{
                                                    margin: '16px',
                                                    background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
                                                    border: '1px solid #e5e7eb',
                                                    borderRadius: '16px',
                                                    overflow: 'hidden',
                                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                onTouchStart={(e) => {
                                                    e.currentTarget.style.transform = 'scale(0.98)';
                                                }}
                                                onTouchEnd={(e) => {
                                                    e.currentTarget.style.transform = 'scale(1)';
                                                }}>
                                                    <div style={{
                                                        background: 'linear-gradient(135deg, #667eea, #764ba2)',
                                                        color: 'white',
                                                        padding: '12px 16px',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center'
                                                    }}>
                                                        <span style={{
                                                            fontSize: '14px',
                                                            fontWeight: '600'
                                                        }}>
                                                            المنتج #{order.id}
                                                        </span>
                                                        <span style={{
                                                            background: 'rgba(255, 255, 255, 0.2)',
                                                            padding: '4px 8px',
                                                            borderRadius: '8px',
                                                            fontSize: '12px',
                                                            fontWeight: '600'
                                                        }}>
                                                            العدد: {order.count}
                                                        </span>
                                                    </div>
                                                    <div style={{
                                                        padding: '16px',
                                                        textAlign: 'right'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '16px',
                                                            fontWeight: '600',
                                                            color: '#374151',
                                                            lineHeight: '1.5'
                                                        }}>
                                                            {order.name}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Enhanced Pagination */}
                                        <div style={{
                                            background: '#f8fafc',
                                            padding: '20px 24px',
                                            borderTop: '1px solid #e5e7eb',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            flexWrap: 'wrap',
                                            gap: '12px'
                                        }}>
                                            <div style={{
                                                fontSize: '14px',
                                                color: '#6b7280',
                                                fontWeight: '500'
                                            }}>
                                                عرض 1-{this.state.orders.length} من {this.state.orders.length} منتج
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                gap: '8px',
                                                alignItems: 'center'
                                            }}>
                                                <button style={{
                                                    background: 'linear-gradient(135deg, #667eea, #764ba2)',
                                                    color: 'white',
                                                    border: 'none',
                                                    padding: '8px 16px',
                                                    borderRadius: '8px',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseOver={(e) => {
                                                    e.target.style.transform = 'translateY(-1px)';
                                                    e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
                                                }}
                                                onMouseOut={(e) => {
                                                    e.target.style.transform = 'translateY(0)';
                                                    e.target.style.boxShadow = 'none';
                                                }}>
                                                    📥 تحميل CSV
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <ToastContainer
                            position="bottom-left"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={true}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                            toastStyle={{
                                borderRadius: '12px',
                                fontFamily: 'inherit'
                            }}
                        />
                    </div>
                )}
            </Context.Consumer>
        );
    }
}

export default Selles_Reports;